import { render, staticRenderFns } from "./FormRender.vue?vue&type=template&id=3da7fc04&scoped=true&"
import script from "./FormRender.vue?vue&type=script&lang=js&"
export * from "./FormRender.vue?vue&type=script&lang=js&"
import style0 from "./FormRender.vue?vue&type=style&index=0&id=3da7fc04&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3da7fc04",
  null
  
)

export default component.exports